export default __webpack_public_path__ + "7a12f2a4793f983658f55e1faa836140.svg";